var B = ["z2v0vgLTzq==", "ww91CIbSAwnLBNnLigv4CgLYzwqGB24G", "zgf0yq==", "uhjVz3jLC3mG", "AgvmshG=", "u2vLia==", "ChjVzhvJDenVzgvZ", "C2nYAxb0s2v5", "D3rmuhm=", "rKjcwKG=", "tM8GBgLJzw5ZzsbMB3vUzc4k", "CgfJA2fNzu5HBwu=", "qvfYAMq=", "CgfYC2u=", "ChjVzhvJDhm=", "igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=", "sgr5sMW=", "rg9iAwe=", "zxDJr2C=", "Du9wCuK=", "z2v0rNvSBfLLyxi=", "lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==", "C2v0", "zxrNsxC=", "C29YDa==", "EeXMBLu=", "AgfZ", "s0XeCe8=", "rM1Ttxy=", "tNvstvG=", "ww91CIb0CMLHBcbSAwnLBNnLigv4CgLYzwqGB24G", "z2v0rgf0zq==", "BgvUz3rO", "txPHwe8=", "BgLJzw5Zzuv4CgLYyxrPB25eyxrL", "DhjPywW=", "vejxq3K=", "r2Ltv1q=", "uhPWBva=", "z2v0", "vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=", "z2v0tw9UDgG=", "s2DnDfK=", "DMvYC2LVBG==", "rKj6sum=", "DgLTzxn0yw1W", "B2jQzwn0", "DhLWzq==", "BgLJzw5ZAw5Nrg9JC1vYBa==", "BMfTzq==", "DwTXAeq=", "zg9JC1vYBa==", "z3jVDxbfBMq=", "z3jVDxa=", "yuDyzhy=", "zMLUza==", "D2fYBG==", "zNvUy3rPB24=", "Dw5KzwzPBMvK", "ChjVzhvJDe5HBwu=", "y29Uy2f0", "ChvIBgLZAerHDgu=", "zxHWAxj5rgf0zq==", "CeDhAfu=", "y29Kzq==", "Dg9mB2nHBgvtDhjPBMC=", "tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG"];
(function(e, i) {
  var r = function(n) {
    for (; --n; )
      e.push(e.shift());
  };
  r(++i);
})(B, 439);
var x = function(e, i) {
  e = e - 0;
  var r = B[e];
  if (x.aWziBr === void 0) {
    var n = function(g) {
      for (var f = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=", t = String(g).replace(/=+$/, ""), v = "", c = 0, o, u, C = 0; u = t.charAt(C++); ~u && (o = c % 4 ? o * 64 + u : u, c++ % 4) ? v += String.fromCharCode(255 & o >> (-2 * c & 6)) : 0)
        u = f.indexOf(u);
      return v;
    };
    x.XjGMHe = function(g) {
      for (var f = n(g), t = [], v = 0, c = f.length; v < c; v++)
        t += "%" + ("00" + f.charCodeAt(v).toString(16)).slice(-2);
      return decodeURIComponent(t);
    }, x.XQgCdR = {}, x.aWziBr = !![];
  }
  var a = x.XQgCdR[e];
  return a === void 0 ? (r = x.XjGMHe(r), x.XQgCdR[e] = r) : r = a, r;
}, w = { data: '  {"timestamp":1684241449,"products":[{"trial":false,"code":"KENDOUIREACT","licenseExpirationDate":1778832276}],"integrity":"xJYzngIVV38o0xdph5uQBq+QdrM="}  ' }, s = /* @__PURE__ */ new Map();
function D(e) {
}
function L(e) {
  if (s[x("0x38")](e[x("0xc")]) && x("0x3a") === x("0x3a"))
    return s[x("0x2")](e[x("0xc")]);
  var i = e[x("0x6")] ? " v" + e[x("0x6")] : "", r = e[x("0xc")] + i, n = JSON[x("0x2b")](w[x("0x20")]), a = !n[x("0x25")] && !n[x("0x8")], g = n[x("0x25")] && typeof KendoLicensing === x("0x15"), f = y(n, e[x("0x24")]), t;
  if (a || g ? x("0x2a") === x("0x2f") || (t = { type: 0, packageName: r, docsUrl: e[x("0xb")] }) : x("0x39") === x("0x39") && (f ? f[x("0x41")] === !![] && l(b(), f[x("0x40")]) ? x("0x0") === x("0x0") && (t = { type: 3, packageName: r, expiryDate: z(f[x("0x40")]), docsUrl: e[x("0xb")] }) : l(e[x("0x18")], f[x("0x40")]) && (x("0x22") !== x("0x22") || (t = { type: 2, packageName: r, publishDate: z(e[x("0x18")]), expiryDate: z(f[x("0x40")]), docsUrl: e[x("0xb")] })) : x("0x1a") !== x("0x1a") || (t = { type: 1, packageName: r, docsUrl: e[x("0xb")] })), t && typeof console === x("0x9") && x("0x5") === x("0x5")) {
    var v = x("0x21")[x("0x17")](e[x("0x16")]), c = typeof console[x("0x10")] === x("0x14");
    c ? x("0x2e") === x("0x2e") && console[x("0x10")](v) : x("0x30") !== x("0x7") && console[x("0x13")](v), console[x("0x13")](h(t)), c && (x("0xd") !== x("0xd") || console[x("0xf")]());
  }
  var o = !t;
  return s[x("0x34")](e[x("0xc")], o), o;
}
function h(e) {
  var i = x("0x1d")[x("0x17")](e[x("0x29")], `
`);
  return e[x("0xa")] === 2 && x("0x3f") !== x("0x1") && (i += x("0x1f")[x("0x17")](e[x("0x19")][x("0x1c")](), x("0x33"))[x("0x17")](e[x("0x18")][x("0x1c")](), `.
`)), e[x("0xa")] === 3 ? x("0x11") === x("0x11") && (i += x("0x3c")[x("0x17")](e[x("0x19")][x("0x1c")](), `.
`)) : e[x("0xa")] === 0 ? x("0x35") === x("0x35") && (i += x("0x28")) : e[x("0xa")] === 1 && (x("0x26") !== x("0x26") || (i += x("0x3"))), i += x("0x23")[x("0x17")](e[x("0xe")], x("0x2d")), i;
}
function y(e, i) {
  var r = e[x("0x2c")];
  if ((!r || !r[x("0x3e")]) && x("0x27") !== x("0x37"))
    return null;
  var n = new Set(i);
  return r[x("0x36")](function(a, g) {
    if (x("0x42") !== x("0x31"))
      return g[x("0x40")] - a[x("0x40")];
  })[x("0x12")](function(a) {
    if (x("0x3b") === x("0x3b"))
      return n[x("0x38")](a[x("0x1b")]);
  });
}
function z(e) {
  return new Date(e * 1e3);
}
function b() {
  return (/* @__PURE__ */ new Date())[x("0x1e")]() / 1e3;
}
function l(e, i) {
  var r = z(i), n = new Date(r[x("0x32")](), r[x("0x4")](), r[x("0x3d")]() + 1), a = n[x("0x1e")]() / 1e3;
  return e > a;
}
const p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setScriptKey: D,
  validatePackage: L
}, Symbol.toStringTag, { value: "Module" }));
export {
  p as l,
  L as v
};
